function CallIcon({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="40">
      <path
        className={className}
        d="M14.234 11.715a.98.98 0 01-1.386 0l-1.04-1.04-1.038-1.042a.974.974 0 010-1.387l.492-.492a6.832 6.832 0 00-6.535 0l.492.492a.974.974 0 010 1.387l-1.04 1.043-1.038 1.039a.98.98 0 01-1.387 0L.71 10.675a2.454 2.454 0 010-3.468l.348-.348c3.816-3.816 10.054-3.816 13.87 0l.348.348a2.454 2.454 0 010 3.469zm0 0"
      ></path>
    </svg>
  );
}

export default CallIcon;
